import React from "react"
import {Route, Redirect, RouteProps} from "react-router-dom"

// Constants
import {AppRoute} from "../../constants"

type PrivateRouteProps = RouteProps & {
    isAuthorized: boolean
}

/**
 * @param props
 */
export default function PrivateRoute(props: PrivateRouteProps) {
    const {isAuthorized, component: Component, ...rest} = props;

    if (isAuthorized === false) {
        return <Redirect to={{
            pathname: AppRoute.SignIn,
            state: {
                from: rest.location,
            },
        }}/>;
    }

    // @ts-ignore
    return <Route {...rest} render={props => <Component {...props}/>}/>
}
